import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import ErrorBoundary from "./errors/ErrorBoundary"; // adicionado aqui

ReactDOM.render(
	<BrowserRouter>
		<CssBaseline>
			<ErrorBoundary>
				<App />
			</ErrorBoundary>
		</CssBaseline>
	</BrowserRouter>,
	document.getElementById("root")
);

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
